import * as pickersApi from "@/api/one_c_pickers";
import type { PickerRow } from "@/components/pickers/RemotePicker";

/** Организации приходят с доп. полями (полное имя, ОПФ) — здесь они не нужны,
 *  сводим к {ref,name}, чтобы все пикеры страницы были одного типа. */
export const searchOrganizations = (q: string): Promise<PickerRow[]> =>
  pickersApi.searchOrganizations(q).then((rows) => rows.map((r) => ({ ref: r.ref, name: r.name })));

export const searchWarehouses = (q: string): Promise<PickerRow[]> =>
  pickersApi.searchStructuralUnits("Склад", q);

export const searchDepartments = (q: string): Promise<PickerRow[]> =>
  pickersApi.searchStructuralUnits("Подразделение", q);
